import { createTheme } from '@mui/material/styles';
import { lightPalette } from './palette';
import typography from './typography';
import getComponents from './components';

const lightTheme = createTheme({
  palette: lightPalette,
  typography,
  components: getComponents('light'),
  shape: { borderRadius: 8 },
});

export default lightTheme;
